var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['socket', _vm.type, _vm.socket.name, _vm.used ? 'used' : ''],attrs:{"title":_vm.socket.name}})}
var staticRenderFns = []

export { render, staticRenderFns }